<template>
  <div class="news-page">
    <h1>移民资讯</h1>

    <section class="news-list">
      <div v-for="item in newsList" :key="item.id" class="news-item" @click="handleNewsClick(item)">
        <h2>{{ item.title }}</h2>
        <div class="news-meta">
          <span class="date">{{ item.date }}</span>
        </div>
        <div class="content">
          <p>{{ item.content }}</p>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="allNews.length"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="handlePageChange"
        />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'NewsView',
  data() {
    return {
      currentPage: 1,
      pageSize: 3,
      allNews: [
        {
          id: 1,
          title: 'IRCC对EE快速通道类别进行了重大修改',
          date: '2024-01-15',
          content: 'IRCC宣布对快速通道Express Entry类别进行重大修改，包括新的评分标准和申请流程优化。这些变化旨在提高系统效率并更好地满足加拿大劳动力市场需求。'
        },
        {
          id: 2,
          title: '加拿大新的家庭护理人员移民项目即将开始实施',
          date: '2024-01-10',
          content: '加拿大新的家庭护理人员移民试点项目（Home Care Worker Immigration Pilots) 将于 2025 年 3 月 31 日开始实施。该项目将有助于解决加拿大社会对家庭护理人员的需求，并为从事这些护理工作的外国人提供了一条获得加拿大永久居民身份的途径。'
        },
        {
          id:3,
          title: 'IRCC开始实施新的规则，移民官可根据情况取消4类临时居民的签证',
          date: '2024-01-05',
          content: '2025年2月12日，IRCC在其官方网页发布实施新规则的通知，新规则赋予移民和边境服务CBSA官员明确的权力，可以根据具体情况取消以下４类临时居民文件，以确保加拿大的移民体系不会被滥用。'
        },
        {
          id:4,
          title: '加拿大发布实施农村和法语社区移民试点项目',
          date: '2024-01-05',
          content: '今天（1月30日），移民部长宣布实施两个移民试点项目：农村社区移民试点项目the Rural Community Immigration Pilot (RCIP)和法语社区移民试点项目the Francophone Community Immigration Pilot (FCIP)。'
        },
        {
          id:5,
          title: 'IRCC新规：允许超级签证申请人从加拿大以外的保险公司购买个人医疗保险',
          date: '2024-01-05',
          content: 'IRCC昨天（1月28日）发布新规定，自2025年1月28日起，父母和祖父母申请加拿大超级签证时，可购买加拿大以外的保险公司提供的医疗保险，以满足医疗保险证明的要求。这一政策的变化将使得超级签证更容易获得。'
        },
      ]
    }
  },
  computed: {
    newsList() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.allNews.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.allNews.length / this.pageSize);
    }
  },
  methods: {
    handlePageChange(page) {
      this.currentPage = page;
    },
    handleNewsClick(item) {
      if (item.id === 1) {
        this.$router.push('/immigration/ee-update');
      } else if (item.id === 2) {
        this.$router.push('/immigration/home-care-worker');
      }
    }
  }
}
</script>

<style lang="less" scoped>
.news-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  h1 {
    text-align: center;
    margin-bottom: 40px;
    color: #333;
    font-size: 32px;
    font-weight: bold;
  }

  .news-list {
    .news-item {
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
      padding: 35px;
      margin-bottom: 30px;
      border: 1px solid #f0f0f0;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
      }

      h2 {
        color: #e63946;
        font-size: 26px;
        margin-bottom: 15px;
        font-weight: bold;
        position: relative;
        padding-left: 15px;

        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 20px;
          background: #e63946;
          border-radius: 2px;
        }
      }

      .news-meta {
        margin-bottom: 20px;
        
        .date {
          color: #666;
          font-size: 14px;
          padding-left: 15px;
        }
      }

      .content {
        p {
          color: #333;
          line-height: 1.8;
          margin: 0;
          text-align: justify;
          font-size: 16px;
          padding-left: 15px;
        }
      }
    }

    .pagination {
      text-align: center;
      margin-top: 40px;

      /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #e63946;
      }

      /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #e63946;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .news-page {
    padding: 20px;

    h1 {
      font-size: 28px;
      margin-bottom: 30px;
    }

    .news-list {
      .news-item {
        padding: 25px;

        h2 {
          font-size: 22px;
        }
      }
    }
  }
}
</style>